<template>
  <vuetable
    :api-mode="false"
    :fields="fields"
    :data="data"
    :css="tableCss"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template
      v-for="(_, slot) of $scopedSlots"
      v-slot:[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
  </vuetable>
</template>

<script>
import Vuetable from 'vuetable-2'

export default {
  components: {
    Vuetable
  },

  props: {
    fields: {
      type: Array,
      default: () => ([])
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    tableCss: () => ({
      tableWrapper: 'table-responsive',
      tableClass: 'table table-striped table-borderless',
      ascendingIcon: 'fa fa-sort-asc',
      descendingIcon: 'fa fa-sort-desc'
    })
  }
}
</script>

<style lang="scss" scoped>
.table-responsive {
  font-size: 12px;
}

::v-deep(.table td) {
  vertical-align: middle;
}

::v-deep(.table-striped tbody tr:nth-of-type(odd)) {
  background: #F5F6FE;
}

::v-deep(th.sortable) {
  color: #18B2BD;
}
</style>
